export enum LayoutHierarchy { // First > Second > Third > Fourth > Fifth
  First = 100004, // Cookie banner
  Second = 100003, // Onboarding popup, Verification popup, Remove parcel popup
  Third = 100002, // Header (desktop + mobile), Dropdown menu
  Fourth = 100001, // Header, TW, Filter (mobile), CCPA
  Fifth = 99999, // Ads
  Sixth = 99998, // Reports popup
}
